export const ugeStrokeSizes = ['none', 'thin', 'normal', 'thick'] as const

type UgeStrokeSize = typeof ugeStrokeSizes[number]

export function strokeLabel(size: UgeStrokeSize): string {
    switch (size) {
        case 'none':
            return 'None'
        case 'thin':
            return 'Thin'
        case 'normal':
            return 'Normal'
        case 'thick':
            return 'Thick'
    }
}

export function strokeWidth(size: UgeStrokeSize): number {
    switch (size) {
        case 'none':
            return 0
        case 'thin':
            return 2
        case 'normal':
            return 4
        case 'thick':
            return 6
    }
}

export default UgeStrokeSize
